import * as React from "react";
export class Row extends React.Component {
    render() {
        return (React.createElement("div", { className: "rj-racing-next-races__row", id: this.props.id }, this.props.children));
    }
}
//# sourceMappingURL=Row.js.map